// Blog content registry — shared by BlogView (post renderer) and
// BlogIndexView (/blog/ hubs). Lives outside the component files so
// react-refresh/only-export-components stays clean (2026-08-31).
import ankiWithoutKo from '../../content/blog/english-vocab-without-anki.ko.md?raw'
import youtubeVocabKo from '../../content/blog/youtube-english-vocab-organize.ko.md?raw'
import dictAppGuideKo from '../../content/blog/english-dictionary-app-guide.ko.md?raw'
import ytFixKo from '../../content/blog/youtube-english-fix.ko.md?raw'
import lrAlternativesEn from '../../content/blog/language-reactor-alternatives.en.md?raw'
import lrAlternativesKo from '../../content/blog/language-reactor-alternatives.ko.md?raw'
import youtubeEikaiwaJa from '../../content/blog/youtube-eikaiwa-study-method.ja.md?raw'
import welcomeEn from '../../content/blog/welcome.en.md?raw'
import welcomeKo from '../../content/blog/welcome.ko.md?raw'
import welcomeJa from '../../content/blog/welcome.ja.md?raw'
import youtubeVocabCardsKo from '../../content/blog/youtube-vocab-cards-from-youtube.ko.md?raw'
import englishWordCardComparisonKo from '../../content/blog/english-word-card-comparison.ko.md?raw'
import youtubeVocabCardsZhTw from '../../content/blog/youtube-vocab-cards-from-youtube.zh-TW.md?raw'
import youtubeVocabCardsJa from '../../content/blog/youtube-vocab-cards-from-youtube.ja.md?raw'
import saveWordsEn from '../../content/blog/save-words-from-youtube-subtitles.en.md?raw'
import lrExportEn from '../../content/blog/language-reactor-export-to-anki.en.md?raw'
import welcomeZh from '../../content/blog/welcome.zh.md?raw'
import welcomeZhTw from '../../content/blog/welcome.zh-TW.md?raw'
import youtubeEikaiwaSelfStudyJa from '../../content/blog/youtube-eikaiwa-self-study.ja.md?raw'
import vocabMemorizationKo from '../../content/blog/english-vocab-memorization-methods.ko.md?raw'
import ieltsVocabKo from '../../content/blog/ielts-vocabulary-notebook.ko.md?raw'
import core1200ZhTw from '../../content/blog/core-1200-vocab-practice.zh-TW.md?raw'
import toeicVocabZhTw from '../../content/blog/toeic-vocab-building.zh-TW.md?raw'
import wordCardHowToJa from '../../content/blog/english-word-card-how-to.ja.md?raw'
import civilServiceVocabKo from '../../content/blog/civil-service-english-vocab.ko.md?raw'
import phrasalVerbsKo from '../../content/blog/phrasal-verbs-notebook.ko.md?raw'
import vocabListDownloadZhTw from '../../content/blog/english-vocab-list-download.zh-TW.md?raw'
import ketVocabZhTw from '../../content/blog/ket-vocabulary-prep.zh-TW.md?raw'
import memorizeFastKo from '../../content/blog/memorize-english-words-fast.ko.md?raw'
import memorizeSentencesKo from '../../content/blog/memorize-english-sentences.ko.md?raw'
import vocabPdfKo from '../../content/blog/english-vocab-notebook-pdf.ko.md?raw'
import vocabSitesKo from '../../content/blog/english-vocab-sites.ko.md?raw'
import toeicVocabPdfKo from '../../content/blog/toeic-vocab-pdf.ko.md?raw'

// cluster groups posts into an internal-link mesh (BlogView shows ≤4
// same-cluster links under every post). At 140+ posts, orphan pages lose
// both crawl distribution and topical clustering — clusters are the fix.
import suneungEnglishVocabKo from '../../content/blog/suneung-english-vocab.ko.md?raw'
import conversationVocabBooksKo from '../../content/blog/conversation-vocab-books.ko.md?raw'
import englishConversationSelfStudyKo from '../../content/blog/english-conversation-self-study.ko.md?raw'
import toeflVocabKo from '../../content/blog/toefl-vocab.ko.md?raw'
import howToMemorizeKo from '../../content/blog/how-to-memorize.ko.md?raw'
import englishVocabNotebookKo from '../../content/blog/english-vocab-notebook.ko.md?raw'
import hackersToeicVocabKo from '../../content/blog/hackers-toeic-vocab.ko.md?raw'
import suneungVocabBooksKo from '../../content/blog/suneung-vocab-books.ko.md?raw'
import highSchoolEnglishVocabPdfKo from '../../content/blog/high-school-english-vocab-pdf.ko.md?raw'
import suneungEnglishStudyMethodKo from '../../content/blog/suneung-english-study-method.ko.md?raw'
import toeicEitangoJa from '../../content/blog/toeic-eitango.ja.md?raw'
import eikenEitangoJa from '../../content/blog/eiken-eitango.ja.md?raw'
import chugakuEitangoJa from '../../content/blog/chugaku-eitango.ja.md?raw'
import englishVocabBooksKo from '../../content/blog/english-vocab-books.ko.md?raw'
import englishVocabularyKo from '../../content/blog/english-vocabulary.ko.md?raw'
import whichWordsToLearnEn from '../../content/blog/which-words-to-learn.en.md?raw'
import ankiAlternativeYoutubeVocabEn from '../../content/blog/anki-alternative-youtube-vocab.en.md?raw'
import jeonipEnglishVocabPdfKo from '../../content/blog/jeonip-english-vocab-pdf.ko.md?raw'
import sistanEitangoAppJa from '../../content/blog/sistan-eitango-app.ja.md?raw'
import suteukEnglishVocabKo from '../../content/blog/suteuk-english-vocab.ko.md?raw'
import eitangoOboekataJa from '../../content/blog/eitango-oboekata.ja.md?raw'
import englishListeningStudyMethodJa from '../../content/blog/english-listening-study-method.ja.md?raw'
import middleSchoolEnglishVocabKo from '../../content/blog/middle-school-english-vocab.ko.md?raw'
import toeicSpeakingStudyMethodKo from '../../content/blog/toeic-speaking-study-method.ko.md?raw'
import englishSpeakingStudyMethodJa from '../../content/blog/english-speaking-study-method.ja.md?raw'
import kaishi15kJapaneseAnkiDeckEn from '../../content/blog/kaishi-1-5k-japanese-anki-deck.en.md?raw'
import bestAnkiDecksJapaneseEn from '../../content/blog/best-anki-decks-japanese.en.md?raw'
import hsk1VocabularyEn from '../../content/blog/hsk-1-vocabulary.en.md?raw'
import toeicLcStudyMethodKo from '../../content/blog/toeic-lc-study-method.ko.md?raw'
import elementaryEnglishVocabKo from '../../content/blog/elementary-english-vocab.ko.md?raw'
import jlptN5VocabularyEn from '../../content/blog/jlpt-n5-vocabulary.en.md?raw'
import englishErrorNotebookKo from '../../content/blog/english-error-notebook.ko.md?raw'
import tepsVocabKo from '../../content/blog/teps-vocab.ko.md?raw'
import mostCommonJapaneseWordsEn from '../../content/blog/most-common-japanese-words.en.md?raw'
import practiceReadingKoreanWordsEn from '../../content/blog/practice-reading-korean-words.en.md?raw'
import englishStudyAppsKo from '../../content/blog/english-study-apps.ko.md?raw'
import duolingoAnkiDeckJapaneseEn from '../../content/blog/duolingo-anki-deck-japanese.en.md?raw'
import hsk4VocabularyEn from '../../content/blog/hsk-4-vocabulary.en.md?raw'
import basicEnglishVocabKo from '../../content/blog/basic-english-vocab.ko.md?raw'
import hsk3VocabularyEn from '../../content/blog/hsk-3-vocabulary.en.md?raw'
import lectureToAnkiEn from '../../content/blog/lecture-to-anki.en.md?raw'
import coolEnglishAlternativeKo from '../../content/blog/cool-english-alternative.ko.md?raw'
import hsk2VocabularyEn from '../../content/blog/hsk-2-vocabulary.en.md?raw'
import ankiFuriganaHideEn from '../../content/blog/anki-furigana-hide.en.md?raw'
import genkiVocabularyEn from '../../content/blog/genki-vocabulary.en.md?raw'
import p1000EssentialVocabularyJlptN5En from '../../content/blog/1000-essential-vocabulary-jlpt-n5.en.md?raw'
import topikVocabularyEn from '../../content/blog/topik-vocabulary.en.md?raw'
import pdfToAnkiEn from '../../content/blog/pdf-to-anki.en.md?raw'
import ankiSpanishDeckEn from '../../content/blog/anki-spanish-deck.en.md?raw'
import japaneseLearningAppsEn from '../../content/blog/japanese-learning-apps.en.md?raw'
import nihongoPracticeReadingEn from '../../content/blog/nihongo-practice-reading.en.md?raw'
import notionToAnkiEn from '../../content/blog/notion-to-anki.en.md?raw'
import quizletToAnkiEn from '../../content/blog/quizlet-to-anki.en.md?raw'
import howManyNewAnkiCardsPerDayEn from '../../content/blog/how-many-new-anki-cards-per-day.en.md?raw'
import bestYoutubeChannelsToLearnKoreanEn from '../../content/blog/best-youtube-channels-to-learn-korean.en.md?raw'
export type PostEntry = { source: string; lang: string; title: string; cluster?: string }

export const POSTS: Record<string, PostEntry> = {
  '/blog/english-vocab-without-anki': {
    source: ankiWithoutKo,
    lang: 'ko',
    title: 'Anki 없이 영어 단어 카드 만들기 — 유튜브 자막 클릭 두 번으로 | Piccard',
    cluster: 'card-making',
  },
  '/blog/youtube-english-vocab-organize': {
    source: youtubeVocabKo,
    lang: 'ko',
    title: '유튜브 보다가 영어 단어장 만들기 — 클릭 두 번으로 저장하는 습관 | Piccard',
    cluster: 'youtube-capture',
  },
  '/blog/english-dictionary-app-guide': {
    source: dictAppGuideKo,
    lang: 'ko',
    title: '영어 사전 앱 고르는 기준 — 오프라인·발음기호·CEFR까지 | Piccard',
    cluster: 'tool-picking',
  },
  '/blog/youtube-english-fix': {
    source: ytFixKo,
    lang: 'ko',
    title: '유튜브가 갑자기 영어로 나올 때 — 자막·언어 되돌리는 방법 | Piccard',
    cluster: 'youtube-capture',
  },
  '/blog/language-reactor-alternatives': {
    source: lrAlternativesEn,
    lang: 'en',
    title: 'Language Reactor Alternatives in 2026: 6 Options, Honestly Compared | Piccard',
    cluster: 'language-reactor',
  },
  '/blog/youtube-eikaiwa-study-method': {
    source: youtubeEikaiwaJa,
    lang: 'ja',
    title: 'YouTube 英語学習を成果に変える方法 — 観ている動画から単語カードを作る | Piccard',
    cluster: 'youtube-capture',
  },
  '/blog/youtube-vocab-cards-from-youtube': {
    source: youtubeVocabCardsKo,
    lang: 'ko',
    title: '유튜브 영어 공부로 영어 단어장 만들기 — 자막 클릭 2번으로 완성 | Piccard',
    cluster: 'youtube-capture',
  },
  '/blog/english-word-card-comparison': {
    source: englishWordCardComparisonKo,
    lang: 'ko',
    title: '영어 단어장 추천 2026 — 유튜브 자막 클릭 AI 단어카드 비교 | Piccard',
    cluster: 'tool-picking',
  },
  '/blog/save-words-from-youtube-subtitles': {
    source: saveWordsEn,
    lang: 'en',
    title: 'How to Save Words from YouTube Subtitles (and Actually Remember Them) | Piccard',
    cluster: 'youtube-capture',
  },
  '/blog/language-reactor-export-to-anki': {
    source: lrExportEn,
    lang: 'en',
    title: 'Language Reactor to Anki Export: Fixes & Alternative | Piccard',
    cluster: 'language-reactor',
  },
  '/blog/youtube-eikaiwa-self-study': {
    source: youtubeEikaiwaSelfStudyJa,
    lang: 'ja',
    title: 'YouTube 英会話の独学方法 — 観るだけを話す練習に変える | Piccard',
    cluster: 'youtube-capture',
  },
  '/blog/english-vocab-memorization-methods': {
    source: vocabMemorizationKo,
    lang: 'ko',
    title: '영단어 암기법 — 계속 잊어버리는 이유부터 | Piccard',
    cluster: 'srs-method',
  },
  '/blog/ielts-vocabulary-notebook': {
    source: ieltsVocabKo,
    lang: 'ko',
    title: '아이엘츠 단어장 — 주제별로 모으고 쓰이는 것만 남기는 법 | Piccard',
    cluster: 'exam-vocab',
  },
  '/blog/core-1200-vocab-practice': {
    source: core1200ZhTw,
    lang: 'zh-TW',
    title: '會考 1200 單字線上練習 — 把紙本單字表變成會複習的單字卡 | Piccard',
    cluster: 'exam-vocab',
  },
  '/blog/toeic-vocab-building': {
    source: toeicVocabZhTw,
    lang: 'zh-TW',
    title: 'TOEIC 單字怎麼背 — 從題目情境建立自己的單字庫 | Piccard',
    cluster: 'exam-vocab',
  },
  '/blog/english-word-card-how-to': {
    source: wordCardHowToJa,
    lang: 'ja',
    title: '英単語カードの作り方 — 紙とアプリ、続くほうを選ぶ | Piccard',
    cluster: 'card-making',
  },
  '/blog/civil-service-english-vocab': {
    source: civilServiceVocabKo,
    lang: 'ko',
    title: '공무원 영어 단어장 — 수험 어휘가 남는 방식 | Piccard',
    cluster: 'exam-vocab',
  },
  '/blog/phrasal-verbs-notebook': {
    source: phrasalVerbsKo,
    lang: 'ko',
    title: '숙어 단어장 — put off를 put과 off로 알지 않는 법 | Piccard',
    cluster: 'vocab-notebook',
  },
  '/blog/english-vocab-list-download': {
    source: vocabListDownloadZhTw,
    lang: 'zh-TW',
    title: '英文單字表下載之後 — PDF 怎麼變成會複習的單字卡 | Piccard',
    cluster: 'vocab-notebook',
  },
  '/blog/ket-vocabulary-prep': {
    source: ketVocabZhTw,
    lang: 'zh-TW',
    title: 'KET 單字怎麼準備 — 劍橋英檢 A2 Key 單字表變成練習 | Piccard',
    cluster: 'exam-vocab',
  },
  '/blog/memorize-english-words-fast': {
    source: memorizeFastKo,
    lang: 'ko',
    title: '영어 단어 빨리 외우는 법 — 시간이 아니라 회독을 줄이는 문제 | Piccard',
    cluster: 'srs-method',
  },
  '/blog/memorize-english-sentences': {
    source: memorizeSentencesKo,
    lang: 'ko',
    title: '영어 문장 외우기 — 통째로 외우면 안 남는 이유 | Piccard',
    cluster: 'srs-method',
  },
  '/blog/english-vocab-notebook-pdf': {
    source: vocabPdfKo,
    lang: 'ko',
    title: '영어 단어장 pdf — 받고 나서 세 페이지에서 멈추는 이유 | Piccard',
    cluster: 'vocab-notebook',
  },
  '/blog/english-vocab-sites': {
    source: vocabSitesKo,
    lang: 'ko',
    title: '영단어 암기 사이트 정리 — 세트형·수업형·앱·직접 만들기 | Piccard',
    cluster: 'tool-picking',
  },
  '/blog/toeic-vocab-pdf': {
    source: toeicVocabPdfKo,
    lang: 'ko',
    title: '토익 영단어 pdf — 목록은 다 비슷하고 갈리는 건 받은 다음이다 | Piccard',
    cluster: 'exam-vocab',
  },
  '/blog/suneung-english-vocab': {
    source: suneungEnglishVocabKo,
    lang: 'ko',
    title: '수능 영단어 — 범위는 공개된 적이 없고, 빈출 목록은 재료다 | Piccard',
    cluster: 'exam-vocab',
  },
  '/blog/conversation-vocab-books': {
    source: conversationVocabBooksKo,
    lang: 'ko',
    title: '영어 회화 단어 책 추천 — 기준 없이 고르면 책장에서 끝난다 | Piccard',
      cluster: 'vocab-notebook',
  },
  '/blog/english-conversation-self-study': {
    source: englishConversationSelfStudyKo,
    lang: 'ko',
    title: '영어 회화 독학 — 루트는 세 단계고, 무너지는 곳은 어휘다 | Piccard',
      cluster: 'srs-method',
  },
  '/blog/toefl-vocab': {
    source: toeflVocabKo,
    lang: 'ko',
    title: '토플 단어 — 공식 목록은 없고, 강의와 지문이 범위다 | Piccard',
      cluster: 'exam-vocab',
  },
  '/blog/how-to-memorize': {
    source: howToMemorizeKo,
    lang: 'ko',
    title: '암기 잘하는 법 — 잘 외우는 사람은 뇌가 아니라 스케줄이 다르다 | Piccard',
      cluster: 'srs-method',
  },
  '/blog/english-vocab-notebook': {
    source: englishVocabNotebookKo,
    lang: 'ko',
    title: '영어 단어장 — 종이·책·pdf·앱·카드, 종류별로 잘하는 일이 다르다 | Piccard',
      cluster: 'vocab-notebook',
  },
  '/blog/hackers-toeic-vocab': {
    source: hackersToeicVocabKo,
    lang: 'ko',
    title: '해커스 토익 단어 — 다시 읽는 것과 다시 떠올리는 것은 다른 일이다 | Piccard',
    cluster: 'tool-picking',
  },
  '/blog/suneung-vocab-books': {
    source: suneungVocabBooksKo,
    lang: 'ko',
    title: '수능 영어 단어장 추천 — 책을 고르는 기준과 책을 안 사는 쪽 | Piccard',
    cluster: 'exam-vocab',
  },
  '/blog/high-school-english-vocab-pdf': {
    source: highSchoolEnglishVocabPdfKo,
    lang: 'ko',
    title: '고등 필수 영단어 pdf — 찾는 목록은 없고, 받은 목록이 범위다 | Piccard',
    cluster: 'exam-vocab',
  },
  '/blog/suneung-english-study-method': {
    source: suneungEnglishStudyMethodKo,
    lang: 'ko',
    title: '수능 영어 공부법 — 순서는 다 아는데, 무너지는 건 복습이다 | Piccard',
    cluster: 'srs-method',
  },
  '/blog/toeic-eitango': {
    source: toeicEitangoJa,
    lang: 'ja',
    title: 'TOEIC 単語の覚え方 — 覚える日より、戻ってくる日の設計 | Piccard',
    cluster: 'exam-vocab',
  },
  '/blog/eiken-eitango': {
    source: eikenEitangoJa,
    lang: 'ja',
    title: '英検 単語の覚え方 — 級が上がってもゼロから組み直さない | Piccard',
    cluster: 'exam-vocab',
  },
  '/blog/chugaku-eitango': {
    source: chugakuEitangoJa,
    lang: 'ja',
    title: '中学 英 単語 一覧 — 範囲は決まっている。問題は回すほう | Piccard',
    cluster: 'exam-vocab',
  },
  '/blog/english-vocab-books': {
    source: englishVocabBooksKo,
    lang: 'ko',
    title: '영어 단어 책 추천 — 더 좋은 책이 아니라 끝낼 수 있는 책 | Piccard',
    cluster: 'vocab-notebook',
  },
  '/blog/english-vocabulary': {
    source: englishVocabularyKo,
    lang: 'ko',
    title: '영어 어휘 — 늘리는 게 아니라 범위를 잡고 걸러내는 일 | Piccard',
    cluster: 'vocab-notebook',
  },
  '/blog/which-words-to-learn': {
    source: whichWordsToLearnEn,
    lang: 'en',
    title: 'Which English Words Are Worth Learning? A Three-Part Filter | Piccard',
    cluster: 'youtube-capture',
  },
  '/blog/anki-alternative-youtube-vocab': {
    source: ankiAlternativeYoutubeVocabEn,
    lang: 'en',
    title: 'An Anki Alternative for YouTube Vocabulary: Where the Complexity Actually Lives | Piccard',
    cluster: 'tool-picking',
  },
  '/blog/jeonip-english-vocab-pdf': {
    source: jeonipEnglishVocabPdfKo,
    lang: 'ko',
    title: '편입 영어 단어 pdf — 공통 범위는 없고, 목표 대학 기출이 범위다 | Piccard',
    cluster: 'exam-vocab',
  },
  '/blog/sistan-eitango-app': {
    source: sistanEitangoAppJa,
    lang: 'ja',
    title: 'シス単 アプリ — 見出し語の一覧を、復習が回るデッキに替える | Piccard',
    cluster: 'tool-picking',
  },
  '/blog/suteuk-english-vocab': {
    source: suteukEnglishVocabKo,
    lang: 'ko',
    title: '수능 특강 영어 단어 — 지문에서 걸러낸 것이 그 해의 범위다 | Piccard',
    cluster: 'exam-vocab',
  },
  '/blog/eitango-oboekata': {
    source: eitangoOboekataJa,
    lang: 'ja',
    title: '英単語の覚え方 — 覚えられる人は記憶力ではなく日程が違う | Piccard',
    cluster: 'srs-method',
  },
  '/blog/english-listening-study-method': {
    source: englishListeningStudyMethodJa,
    lang: 'ja',
    title: '英語 リスニング 勉強 法 — 「読めるのに聞き取れない」の正体と、直し方 | Piccard',
    cluster: 'youtube-capture',
  },
  '/blog/middle-school-english-vocab': {
    source: middleSchoolEnglishVocabKo,
    lang: 'ko',
    title: '뜯어먹는 중학영단어 1800 — 범위는 3년치인데 회독은 오늘치다 | Piccard',
    cluster: 'exam-vocab',
  },
  '/blog/toeic-speaking-study-method': {
    source: toeicSpeakingStudyMethodKo,
    lang: 'ko',
    title: '토익 스피킹 공부법 — 알아보는 단어와 꺼낼 수 있는 단어는 다르다 | Piccard',
    cluster: 'srs-method',
  },
  '/blog/english-speaking-study-method': {
    source: englishSpeakingStudyMethodJa,
    lang: 'ja',
    title: '英語が話せるようになるには — 勇気ではなく順番の問題 | Piccard',
    cluster: 'srs-method',
  },
  '/blog/kaishi-1-5k-japanese-anki-deck': {
    source: kaishi15kJapaneseAnkiDeckEn,
    lang: 'en',
    title: 'Kaishi 1.5k: What the Default Japanese Starter Deck Is, and What It Isn\'t | Piccard',
    cluster: 'tool-picking',
  },
  '/blog/best-anki-decks-japanese': {
    source: bestAnkiDecksJapaneseEn,
    lang: 'en',
    title: 'The Best Anki Decks for Japanese (2026): Kaishi, Core, Tango, and the Rest | Piccard',
    cluster: 'tool-picking',
  },
  '/blog/hsk-1-vocabulary': {
    source: hsk1VocabularyEn,
    lang: 'en',
    title: 'HSK 1 Vocabulary: 150 Words or 500? | Piccard',
    cluster: 'exam-vocab',
  },
  '/blog/toeic-lc-study-method': {
    source: toeicLcStudyMethodKo,
    lang: 'ko',
    title: '토익 LC 공부법 — 읽으면 아는 단어가 소리로는 안 잡힌다 | Piccard',
    cluster: 'srs-method',
  },
  '/blog/elementary-english-vocab': {
    source: elementaryEnglishVocabKo,
    lang: 'ko',
    title: '초등 영단어 pdf — 검색하는 사람은 부모고 복습하는 사람은 아이다 | Piccard',
    cluster: 'exam-vocab',
  },
  '/blog/jlpt-n5-vocabulary': {
    source: jlptN5VocabularyEn,
    lang: 'en',
    title: 'JLPT N5 Vocabulary: The List That Isn\'t Official | Piccard',
    cluster: 'exam-vocab',
  },
  '/blog/english-error-notebook': {
    source: englishErrorNotebookKo,
    lang: 'ko',
    title: '영어 오답 노트, 세 페이지에서 끝나는 이유 | Piccard',
    cluster: 'srs-method',
  },
  '/blog/teps-vocab': {
    source: tepsVocabKo,
    lang: 'ko',
    title: '텝스 단어, 어휘 섹션이 따로 있는 시험은 덱이 달라진다 | Piccard',
    cluster: 'exam-vocab',
  },
  '/blog/most-common-japanese-words': {
    source: mostCommonJapaneseWordsEn,
    lang: 'en',
    title: 'The 1000 Most Common Japanese Words: The Core, and the Words Only You Keep Meeting | Piccard',
    cluster: 'vocab-notebook',
  },
  '/blog/practice-reading-korean-words': {
    source: practiceReadingKoreanWordsEn,
    lang: 'en',
    cluster: 'youtube-capture',
    title: 'Practice Reading Korean Words: Why Re-Reading Isn\'t Reading, and What Is | Piccard',
  },
  '/blog/english-study-apps': {
    source: englishStudyAppsKo,
    lang: 'ko',
    cluster: 'tool-picking',
    title: '영어 공부 앱 추천 — 좋은 앱을 고르는 게 아니라 비는 자리를 고른다 | Piccard',
  },
  '/blog/duolingo-anki-deck-japanese': {
    source: duolingoAnkiDeckJapaneseEn,
    lang: 'en',
    cluster: 'tool-picking',
    title: 'From Duolingo to an Anki Deck for Japanese: What Exports, and What Never Will | Piccard',
  },
  '/blog/hsk-4-vocabulary': {
    source: hsk4VocabularyEn,
    lang: 'en',
    cluster: 'exam-vocab',
    title: 'HSK 4 Vocabulary: 600 New Words or 1,000? | Piccard',
  },
  '/blog/basic-english-vocab': {
    source: basicEnglishVocabKo,
    lang: 'ko',
    cluster: 'vocab-notebook',
    title: '기초 영단어, 어디까지가 기초인지 정한 사람은 없다 | Piccard',
  },
  '/blog/hsk-3-vocabulary': {
    source: hsk3VocabularyEn,
    lang: 'en',
    title: 'HSK 3 Vocabulary: 300 New Words or 600? | Piccard',
    cluster: 'exam-vocab',
  },
  '/blog/lecture-to-anki': {
    source: lectureToAnkiEn,
    lang: 'en',
    title: 'Lecture to Anki: Convert the Notes, or the Recording Itself? | Piccard',
    cluster: 'tool-picking',
  },
  '/blog/cool-english-alternative': {
    source: coolEnglishAlternativeKo,
    lang: 'ko',
    title: '쿨 잉글리쉬란 — 학원에서 쓰는 낭독 프로그램, 단어가 남는 자리는 따로 있다 | Piccard',
    cluster: 'tool-picking',
  },
  '/blog/hsk-2-vocabulary': {
    source: hsk2VocabularyEn,
    lang: 'en',
    title: 'HSK 2 Vocabulary: 150 New Words or 300? | Piccard',
    cluster: 'exam-vocab',
  },
  '/blog/anki-furigana-hide': {
    source: ankiFuriganaHideEn,
    lang: 'en',
    title: 'Hiding Furigana in Anki: The Built-In Filters, and the Catch | Piccard',
    cluster: 'tool-picking',
  },
  '/blog/genki-vocabulary': {
    source: genkiVocabularyEn,
    lang: 'en',
    title: 'Genki Vocabulary: Three Honest Ways to Turn 1,700 Words into Cards | Piccard',
    cluster: 'tool-picking',
  },
  '/blog/1000-essential-vocabulary-jlpt-n5': {
    source: p1000EssentialVocabularyJlptN5En,
    lang: 'en',
    title: '1000 Essential Vocabulary for the JLPT N5: What the Book Gives You, and What It Doesn\'t | Piccard',
    cluster: 'exam-vocab',
  },
  '/blog/topik-vocabulary': {
    source: topikVocabularyEn,
    lang: 'en',
    title: 'TOPIK Vocabulary: Two Official Numbers, Then Four Guesses | Piccard',
    cluster: 'exam-vocab',
  },
  '/blog/pdf-to-anki': {
    source: pdfToAnkiEn,
    lang: 'en',
    title: 'PDF to Anki: Four Routes That Work, and Where Each Stops | Piccard',
    cluster: 'tool-picking',
  },
  '/blog/anki-spanish-deck': {
    source: ankiSpanishDeckEn,
    lang: 'en',
    title: 'The Best Anki Spanish Decks (2026): Five Picks, Verified Today | Piccard',
    cluster: 'tool-picking',
  },
  '/blog/japanese-learning-apps': {
    source: japaneseLearningAppsEn,
    lang: 'en',
    title: 'Japanese Learning Apps (2026): What Six Tools Cost and Teach | Piccard',
    cluster: 'tool-picking',
  },
  '/blog/nihongo-practice-reading': {
    source: nihongoPracticeReadingEn,
    lang: 'en',
    title: 'Nihongo Practice Reading: Why Decoding Keeps You Slow, and What Builds Speed | Piccard',
    cluster: 'youtube-capture',
  },
  '/blog/notion-to-anki': {
    source: notionToAnkiEn,
    lang: 'en',
    title: 'Notion to Anki: Add-On, Converter, or a Straight Paste | Piccard',
    cluster: 'tool-picking',
  },
  '/blog/quizlet-to-anki': {
    source: quizletToAnkiEn,
    lang: 'en',
    title: 'Quizlet to Anki: Which Routes Still Work, and Which One Keeps Breaking | Piccard',
    cluster: 'tool-picking',
  },
  '/blog/how-many-new-anki-cards-per-day': {
    source: howManyNewAnkiCardsPerDayEn,
    lang: 'en',
    title: 'How Many New Anki Cards per Day? The Arithmetic Behind 20 | Piccard',
    cluster: 'srs-method',
  },
  '/blog/best-youtube-channels-to-learn-korean': {
    source: bestYoutubeChannelsToLearnKoreanEn,
    lang: 'en',
    title: 'The Best YouTube Channels to Learn Korean (Checked Sept 2026) | Piccard',
    cluster: 'youtube-capture',
  },
  '/welcome': {
    source: welcomeEn,
    lang: 'en',
    title: 'Welcome to Piccard — start in 3 steps | Piccard',
  },
}

// Blog posts with localized versions (SEO pages per market) — a variant is
// a REAL translation rendered at /<locale>/blog/<slug>/; the only
// locale-prefixed post URL that exists (seo-signal-fixes.md).
// ponytail: per-post variants map, minimal generalization for second localized post
export const BLOG_VARIANTS: Record<string, Record<string, PostEntry>> = {
  '/blog/language-reactor-alternatives': {
    ko: {
      source: lrAlternativesKo,
      lang: 'ko',
      title: 'Language Reactor 대안 2026: 6가지 도구 솔직 비교 | Piccard',
    },
  },
  '/blog/youtube-vocab-cards-from-youtube': {
    'zh-TW': {
      source: youtubeVocabCardsZhTw,
      lang: 'zh-TW',
      title: '在 YouTube 記英文單字的方法 — 從正在看的影片直接做成單字卡 | Piccard',
    },
    ja: {
      source: youtubeVocabCardsJa,
      lang: 'ja',
      title: 'YouTubeで英単語を覚える方法 — 見ている動画からそのまま単語カードにする | Piccard',
    },
  },
}

// Blog languages in listing order, plus their endonym labels — shared by
// BlogIndexView and BlogClusterView (kept here so component files export
// only components, the react-refresh rule that created this registry).
export const BLOG_LANGS = ['en', 'ko', 'zh-TW', 'ja'] as const
export const BLOG_LANG_LABEL: Record<string, string> = {
  en: 'English',
  ko: '한국어',
  'zh-TW': '繁體中文',
  ja: '日本語',
}

/** Cluster display names per language (chips on the blog index and hubs;
 *  en is the fallback). */
export const CLUSTER_LABEL: Record<string, Record<string, string>> = {
  'exam-vocab': { en: 'Exam vocabulary', ko: '시험 영어 어휘', ja: '試験の英単語', 'zh-TW': '考試單字' },
  'vocab-notebook': { en: 'Word notebooks', ko: '영어 단어장', ja: '英単語帳', 'zh-TW': '單字表' },
  'srs-method': { en: 'Memorization methods', ko: '암기법', ja: '覚え方', 'zh-TW': '記憶方法' },
  'tool-picking': { en: 'Choosing tools', ko: '공부 도구 고르기', ja: 'ツールの選び方', 'zh-TW': '工具選擇' },
  'youtube-capture': { en: 'YouTube vocabulary', ko: '유튜브 영어', ja: 'YouTube英語', 'zh-TW': 'YouTube 英語' },
  'card-making': { en: 'Making cards', ko: '단어 카드 만들기', ja: 'カードの作り方', 'zh-TW': '單字卡製作' },
  'language-reactor': { en: 'Language Reactor', ko: 'Language Reactor', ja: 'Language Reactor', 'zh-TW': 'Language Reactor' },
}

// ── Cluster hubs (landing-v12 P0: hub-and-spoke) ──────────────────────────
// Display order = blog volume order (exam-vocab families carry the Semrush
// head terms; youtube-capture is the differentiation story). Hubs render at
// /blog/c/<id>/ (en-framed, all languages grouped) and /<locale>/blog/c/<id>/
// for every locale the cluster actually has content in (CLUSTER_LOCALES).
export const CLUSTER_IDS = [
  'exam-vocab',
  'vocab-notebook',
  'srs-method',
  'tool-picking',
  'youtube-capture',
  'card-making',
  'language-reactor',
]

/** Locales with ≥1 page in the cluster — POSTS plus BLOG_VARIANTS (a
 *  variant inherits its parent post's cluster). Decides which locale hub
 *  URLs exist; scripts/seo/audit-wiring.mjs re-derives this from the source
 *  below and diffs it against prerender/sitemap/dist. 'en' is NEVER listed:
 *  the root /blog/c/<id>/ hub IS the English page (site URL policy — en has
 *  no locale prefix). */
export const CLUSTER_LOCALES: Record<string, string[]> = (() => {
  const acc: Record<string, Set<string>> = {}
  const add = (cluster: string | undefined, lang: string) => {
    if (!cluster || lang === 'en') return
    ;(acc[cluster] ??= new Set()).add(lang)
  }
  for (const post of Object.values(POSTS)) add(post.cluster, post.lang)
  for (const [path, variants] of Object.entries(BLOG_VARIANTS))
    for (const v of Object.values(variants)) add(POSTS[path]?.cluster, v.lang)
  return Object.fromEntries(
    CLUSTER_IDS.filter((c) => acc[c]).map((c) => [c, [...acc[c]]]),
  )
})()

// /welcome is the extension onboarding page — the extension opens it with
// ?lang=<locale> (pickWelcomeLang), so the body is localized per visitor.
// Blog posts stay single-language (SEO pages written per market).
export const WELCOME_I18N: Record<string, PostEntry> = {
  ko: {
    source: welcomeKo,
    lang: 'ko',
    title: 'Piccard가 설치되었습니다 — 앱 전부를 소개합니다 | Piccard',
  },
  ja: {
    source: welcomeJa,
    lang: 'ja',
    title: 'Piccardがインストールされました — アプリの全体像 | Piccard',
  },
  zh: {
    source: welcomeZh,
    lang: 'zh',
    title: 'Piccard 已安装 — 这就是整个应用 | Piccard',
  },
  'zh-TW': {
    source: welcomeZhTw,
    lang: 'zh-TW',
    title: 'Piccard 已安裝 — 這就是整個應用 | Piccard',
  },
}
